const CHART_CATEGORIES = {
  BAR: 'bar',
  COLUMN: 'column',
  LINE: 'line',
  AREA: 'area',
  GRID: 'grid',
  CIRCULAR: 'circular',
  TEXT: 'text',
  GEOSPATIAL: 'geospatial',
};

const CHART_CATEGORIES_ICONS = {
  [CHART_CATEGORIES.AREA]: 'area-discrete',
  [CHART_CATEGORIES.BAR]: 'bar-grouped',
  [CHART_CATEGORIES.COLUMN]: 'column-grouped',
  [CHART_CATEGORIES.LINE]: 'line-discrete',
  [CHART_CATEGORIES.GRID]: 'heatmap',
  [CHART_CATEGORIES.TEXT]: 'data-table',
  [CHART_CATEGORIES.CIRCULAR]: 'donut',
  [CHART_CATEGORIES.GEOSPATIAL]: 'geo-choropleth',
};

export { CHART_CATEGORIES, CHART_CATEGORIES_ICONS };
